let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("emd3r"), load("gYdbF"), load("kUbT8")]).then(() => parcelRequire('4KbgO'));